<template>
	<div class="hg-wrap-content" :class="`hg-hexagon-pos-${position}`" @click="scrollTo($event)">
		<p v-if="type == 'vitPar'" class="hg-title">{{ $t('soAppVitalParameter') }}</p>
		<p v-else-if="type == 'quest'" class="hg-title">{{ $t('soAppQuestionnaires') }}</p>
		<p v-else-if="type == 'sensor'" class="hg-title">{{ $t('soAppSensors') }}</p>
		<p v-else-if="type == 'event'" class="hg-title">{{ $t('soAppEvents') }}</p>
		<p v-else-if="type == 'appSec'" class="hg-title">{{ $t('soAppSecurity') }}</p>
		<p v-else-if="type == 'conSec'" class="hg-title">{{ $t('soConSecurity') }}</p>
		<p v-else-if="type == 'dataSec'" class="hg-title">{{ $t('soDataSecurity') }}</p>
		<p v-else-if="type == 'accCont'" class="hg-title">{{ $t('soDataManagement') }}</p>
		<p v-else-if="type == 'operation'" class="hg-title">{{ $t('soOperation') }}</p>
		<p v-else-if="type == 'clientSec'" class="hg-title">{{ $t('soClientSecurity') }}</p>
		<p v-else-if="type == 'config'" class="hg-title">{{ $t('soClientConfig') }}</p>
		<p v-else-if="type == 'dataVis'" class="hg-title">{{ $t('soClientVisualization') }}</p>
		<p v-else-if="type == 'pracTalk'" class="hg-title">{{ $t('soClientPractitioner') }}</p>
		<div class="hg-hexagon-top"></div>
		<div class="hg-hexagon-mid">
			<i v-if="type == 'vitPar'" class="fas fa-heartbeat" :title="$t('soAppVitalParameter')"></i>
			<i v-else-if="type == 'quest'" class="fab fa-wpforms" :title="$t('soAppQuestionnaires')"></i>
			<i v-else-if="type == 'sensor'" class="material-icons" :title="$t('soAppSensors')">sensors</i>
			<i v-else-if="type == 'event'" class="fas fa-exclamation" :title="$t('soAppEvents')"></i>
			<i v-else-if="type == 'appSec'" class="fas fa-shield-alt" :title="$t('soAppSecurity')"></i>
			<i v-else-if="type == 'conSec'" class="fas fa-shield-alt" :title="$t('soConSecurity')"></i>
			<i v-else-if="type == 'dataSec'" class="fas fa-shield-alt" :title="$t('soDataSecurity')"></i>
			<i v-else-if="type == 'accCont'" class="material-icons hg-bigger-icon" :title="$t('soDataManagement')">safety_divider</i>
			<i v-else-if="type == 'operation'" class="fas fa-server" :title="$t('soOperation')"></i>
			<i v-else-if="type == 'clientSec'" class="fas fa-shield-alt" :title="$t('soClientSecurity')"></i>
			<i v-else-if="type == 'config'" class="fas fa-users-cog" :title="$t('soClientConfig')"></i>
			<i v-else-if="type == 'dataVis'" class="fas fa-chart-line" :title="$t('soClientVisualization')"></i>
			<i v-else-if="type == 'pracTalk'" class="fas fa-user-md" :title="$t('soClientPractitioner')"></i>
		</div>
		<div class="hg-hexagon-bot"></div>
	</div>
</template>

<script>
export default {
	name: 'Hexagon',
	props: {
		type: {
			type: String,
			required: true,
		},
		position: {
			type: String,
			required: true,
		},
	},
	data() {
		return {
			lastTarget: null,
		};
	},
	methods: {
		scrollTo(e) {
			if (this.$global.isMobile()) {
				if (this.lastTarget == e.target) this.checkType();
				else this.lastTarget = e.target;
			} else {
				this.checkType();
			}
		},
		checkType() {
			if (this.type == 'vitPar') document.querySelector('#vitalParameters').scrollIntoView({ behavior: 'smooth' });
			else if (this.type == 'quest') document.querySelector('#questionnaire').scrollIntoView({ behavior: 'smooth' });
			else if (this.type == 'sensor') document.querySelector('#sensor').scrollIntoView({ behavior: 'smooth' });
			else if (this.type == 'event') document.querySelector('#event').scrollIntoView({ behavior: 'smooth' });
			else if (this.type == 'appSec') document.querySelector('#appSecurity').scrollIntoView({ behavior: 'smooth' });
			else if (this.type == 'conSec') document.querySelector('#connectionSecurity').scrollIntoView({ behavior: 'smooth' });
			else if (this.type == 'dataSec') document.querySelector('#dataEncryption').scrollIntoView({ behavior: 'smooth' });
			else if (this.type == 'operation') document.querySelector('#operation').scrollIntoView({ behavior: 'smooth' });
			else if (this.type == 'accCont') document.querySelector('#dataManagement').scrollIntoView({ behavior: 'smooth' });
			else if (this.type == 'clientSec') document.querySelector('#clientSecurity').scrollIntoView({ behavior: 'smooth' });
			else if (this.type == 'config') document.querySelector('#configuration').scrollIntoView({ behavior: 'smooth' });
			else if (this.type == 'dataVis') document.querySelector('#visualization').scrollIntoView({ behavior: 'smooth' });
			else if (this.type == 'pracTalk') document.querySelector('#physicianTalk').scrollIntoView({ behavior: 'smooth' });
		},
	},
};
</script>

<style scoped>
.hg-wrap-content {
	position: absolute;
	display: none;
	text-align: center;
	-webkit-animation-duration: 0.5s;
	animation-duration: 0.5s;
	-webkit-animation-fill-mode: both;
	animation-fill-mode: both;
	-webkit-animation-name: fadeIn;
	animation-name: fadeIn;
}

.hg-wrap-content:hover .hg-title {
	display: block;
}

.hg-hexagon-top {
	position: absolute;
	top: 0px;
	width: 0;
	border-bottom: 15px solid var(--main-color-dark);
	border-left: 25px solid transparent;
	border-right: 25px solid transparent;
}
.hg-hexagon-mid {
	width: 50px;
	height: 30px;
	position: absolute;
	top: 15px;
	display: inline-flex;
	align-items: center;
	justify-content: center;
	background-color: var(--main-color-dark);
}

.hg-hexagon-mid i {
	font-size: 30px;
	color: var(--main-color-text-light);
}

.hg-bigger-icon {
	font-size: 40px !important;
}

.hg-hexagon-bot {
	width: 0;
	position: absolute;
	top: 45px;
	border-top: 15px solid var(--main-color-dark);
	border-left: 25px solid transparent;
	border-right: 25px solid transparent;
}

.hg-hexagon-pos-1 {
	top: -1px;
	left: -50px;
	z-index: 4;
}

.hg-hexagon-pos-1-5 {
	top: -25px;
	left: -40px;
	z-index: 4;
}

.hg-hexagon-pos-2 {
	top: -50px;
	left: -10px;
	z-index: 3;
}

.hg-hexagon-pos-2-5 {
	top: -65px;
	left: 15px;
	z-index: 3;
}

.hg-hexagon-pos-3 {
	top: -70px;
	left: 50px;
	z-index: 2;
}

.hg-hexagon-pos-3-5 {
	top: -65px;
	right: 65px;
	z-index: 2;
}

.hg-hexagon-pos-4 {
	top: -50px;
	right: 40px;
	z-index: 3;
}

.hg-hexagon-pos-4-5 {
	top: -25px;
	right: 10px;
	z-index: 3;
}

.hg-hexagon-pos-5 {
	top: 0px;
	right: 0px;
	z-index: 4;
}

.hg-title {
	display: none;
	position: absolute;
	width: 150px;
	top: -40px;
	left: -50px;
	z-index: 4;
	background-color: #ffffffee;
	box-shadow: 0px 0px 5px 5px #ffffffee;
	font-weight: bold;
}

@keyframes fadeIn {
	0% {
		opacity: 0;
		transform: translateY(50px);
	}
	100% {
		opacity: 1;
		transform: translateY(0);
	}
}

@-webkit-keyframes fadeIn {
	0% {
		opacity: 0;
		transform: translateY(50px);
	}
	100% {
		opacity: 1;
		transform: translateY(0);
	}
}

@media screen and (max-width: 900px) {
	.hg-hexagon-top {
		position: absolute;
		top: 0px;
		width: 0;
		border-bottom: 12px solid var(--main-color-dark);
		border-left: 20px solid transparent;
		border-right: 20px solid transparent;
	}
	.hg-hexagon-mid {
		width: 40px;
		height: 20px;
		position: absolute;
		top: 12px;
		display: inline-flex;
		align-items: center;
		justify-content: center;
		background-color: var(--main-color-dark);
	}

	.hg-hexagon-mid i {
		font-size: 20px;
		color: var(--main-color-text-light);
	}

	.hg-bigger-icon {
		font-size: 30px !important;
	}

	.hg-hexagon-bot {
		width: 0;
		position: absolute;
		top: 32px;
		border-top: 12px solid var(--main-color-dark);
		border-left: 20px solid transparent;
		border-right: 20px solid transparent;
	}

	.hg-hexagon-pos-1 {
		top: -5px;
		left: -45px;
		z-index: 4;
	}

	.hg-hexagon-pos-1-5 {
		top: -25px;
		left: -35px;
		z-index: 4;
	}

	.hg-hexagon-pos-2 {
		top: -45px;
		left: -15px;
		z-index: 3;
	}

	.hg-hexagon-pos-2-5 {
		top: -60px;
		left: 0px;
		z-index: 3;
	}

	.hg-hexagon-pos-3 {
		top: -60px;
		left: 35px;
		z-index: 2;
	}

	.hg-hexagon-pos-3-5 {
		top: -60px;
		right: 50px;
		z-index: 2;
	}

	.hg-hexagon-pos-4 {
		top: -45px;
		right: 25px;
		z-index: 3;
	}

	.hg-hexagon-pos-4-5 {
		top: -25px;
		right: 5px;
		z-index: 3;
	}

	.hg-hexagon-pos-5 {
		top: -5px;
		right: -5px;
		z-index: 4;
	}

	.hg-title {
		display: none;
		position: absolute;
		width: 150px;
		top: -40px;
		left: -50px;
		z-index: 4;
		background-color: #ffffffee;
		box-shadow: 0px 0px 5px 5px #ffffffee;
		font-weight: bold;
	}
}

@media screen and (max-width: 700px) {
	.hg-hexagon-top {
		position: absolute;
		top: 0px;
		width: 0;
		border-bottom: 12px solid var(--main-color-dark);
		border-left: 20px solid transparent;
		border-right: 20px solid transparent;
	}
	.hg-hexagon-mid {
		width: 40px;
		height: 20px;
		position: absolute;
		top: 12px;
		display: inline-flex;
		align-items: center;
		justify-content: center;
		background-color: var(--main-color-dark);
	}

	.hg-hexagon-mid i {
		font-size: 20px;
		color: var(--main-color-text-light);
	}

	.hg-bigger-icon {
		font-size: 30px !important;
	}

	.hg-hexagon-bot {
		width: 0;
		position: absolute;
		top: 32px;
		border-top: 12px solid var(--main-color-dark);
		border-left: 20px solid transparent;
		border-right: 20px solid transparent;
	}

	.hg-hexagon-pos-1 {
		top: -50px;
		left: 65px;
		z-index: 4;
	}

	.hg-hexagon-pos-1-5 {
		top: -35px;
		left: 85px;
		z-index: 4;
	}

	.hg-hexagon-pos-2 {
		top: -15px;
		left: 105px;
		z-index: 3;
	}

	.hg-hexagon-pos-2-5 {
		top: 0px;
		left: 120px;
		z-index: 3;
	}

	.hg-hexagon-pos-3 {
		top: 30px;
		left: 130px;
		z-index: 2;
	}

	.hg-hexagon-pos-3-5 {
		top: 55px;
		right: -10px;
		z-index: 2;
	}

	.hg-hexagon-pos-4 {
		top: 75px;
		right: 0px;
		z-index: 3;
	}

	.hg-hexagon-pos-4-5 {
		top: 95px;
		right: 20px;
		z-index: 3;
	}

	.hg-hexagon-pos-5 {
		top: 110px;
		right: 40px;
		z-index: 4;
	}

	.hg-title {
		display: none;
		position: absolute;
		width: fit-content;
		padding: 2px 5px;
		top: -5px;
		left: 50px;
		z-index: 4;
		background-color: #ffffffee;
		box-shadow: 0px 0px 5px 5px #ffffffee;
		font-weight: bold;
	}

	@keyframes fadeIn {
		0% {
			opacity: 0;
		}
		100% {
			opacity: 1;
		}
	}

	@-webkit-keyframes fadeIn {
		0% {
			opacity: 0;
		}
		100% {
			opacity: 1;
		}
	}
}

@media (pointer: none), (pointer: coarse) {
	.hg-hexagon-pos-1 {
		top: -50px;
		left: 15px;
		z-index: 4;
	}

	.hg-hexagon-pos-1-5 {
		top: -45px;
		left: 35px;
		z-index: 4;
	}

	.hg-hexagon-pos-2 {
		top: -30px;
		left: 60px;
		z-index: 3;
	}

	.hg-hexagon-pos-2-5 {
		top: -15px;
		left: 75px;
		z-index: 3;
	}

	.hg-hexagon-pos-3 {
		top: 10px;
		left: 75px;
		z-index: 2;
	}

	.hg-hexagon-pos-3-5 {
		top: 35px;
		right: -5px;
		z-index: 2;
	}

	.hg-hexagon-pos-4 {
		top: 55px;
		right: 10px;
		z-index: 3;
	}

	.hg-hexagon-pos-4-5 {
		top: 75px;
		right: 30px;
		z-index: 3;
	}

	.hg-hexagon-pos-5 {
		top: 75px;
		right: 55px;
		z-index: 4;
	}
}
</style>
